import { create } from 'zustand'

/**
 * Tracks how many MobileBottomSheets are currently open. App chrome that
 * floats over the page (e.g. the home page's "Chat with Taka" bottom bar)
 * subscribes to `useAnyBottomSheetOpen` and hides itself when a sheet is up.
 *
 * Why the explicit hide rather than relying on z-index: iOS Safari has known
 * issues where elements with `backdrop-filter` (the chat bar uses one) render
 * above other fixed siblings regardless of z-index, so the chat bar pokes
 * through the bottom of the sheet.
 */
interface BottomSheetState {
  openCount: number
  increment: () => void
  decrement: () => void
}

export const useBottomSheetStore = create<BottomSheetState>(set => ({
  openCount: 0,
  increment: () => set(state => ({ openCount: state.openCount + 1 })),
  decrement: () => set(state => ({ openCount: Math.max(0, state.openCount - 1) })),
}))

export function useAnyBottomSheetOpen(): boolean {
  return useBottomSheetStore(s => s.openCount > 0)
}
